// ABOUTME: Owner actions on a variation group. Mirrors app/api/v1/variation_actions.py
// (pick) and variation_previews.py (the preview link the exact mockups are read through).
import { api } from '@/api/client'

export interface PickVariationResult {
  variation_group_id: string
  draft_id: string
  status: string
  /** Null when no post is planned for the option yet: picked, nothing scheduled. */
  scheduled_at: string | null
}

export interface VariationPreviewLink {
  variation_group_id: string
  url: string
  expires_at: string
}

/** Pick one option; the other options close. `idempotency_key` makes a retry safe. */
export async function pickVariation(
  groupId: string,
  draftId: string,
  idempotencyKey: string
): Promise<PickVariationResult> {
  return (await api.post<PickVariationResult>(`/variation-groups/${groupId}/pick`, {
    draft_id: draftId,
    idempotency_key: idempotencyKey,
  })) as unknown as PickVariationResult
}

export async function createVariationPreviewLink(groupId: string): Promise<VariationPreviewLink> {
  return (await api.post<VariationPreviewLink>(
    `/variation-groups/${groupId}/preview-link`
  )) as unknown as VariationPreviewLink
}

/** The token a preview link's URL ends in (`/p/{token}`). */
export function previewTokenFromUrl(url: string): string {
  return url.split('?')[0].replace(/\/+$/, '').split('/').pop() ?? ''
}
